// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListProjectsList-modulelist__E9mFh";
export { _1 as "list" }
